import React, { useEffect, useState } from 'react'
import Api from '../../../../_helpers/Api'

//components
import Material from './partials/Material'

//images
import loader from '../../../../assets/images/app/loader.svg'
import notStarted from '../../../../assets/images/pages/icons/not-started.png'
import tableFilterIcon from '../../../../assets/images/pages/icons/table-filter.png'

function Index() {
    const [materials, setMaterials] = useState({
        data: [],
        loading: true,
        filter: {
            price: 'price-asc'
        }
    })

    useEffect(() => {
        startLoading()

        Api.get(`dashboard/finance?sort=${materials.filter.price}`)
            .then(res => {
                setMaterials(materials => ({
                    ...materials,
                    data: res.data ? res.data : [],
                }))
            })
            .finally(() => stopLoading())
    }, [materials.refresh, materials.filter])
    const startLoading = () => {
        setMaterials(materials => ({
            ...materials,
            loading: true,
        }))
    }
    const stopLoading = () => {
        setMaterials(materials => ({
            ...materials,
            loading: false,
        }))
    }

    const handleQuantityFilter = () => {
        setMaterials(prev => ({
            ...prev,
            filter: {
                ...prev.filter,
                price: materials.filter.price == 'price-asc' ? 'price-desc' : 'price-asc'
            }
        }))
    }

    return (
        <div className="holder">
            {materials.loading ?
                <img src={loader} alt="loading" />
                :
                materials.data.length == 0 ?
                    <div className="no-results">
                        <img src={notStarted} alt="В норма" />
                        Все още нямате
                        <br />
                        финансови операции.
                    </div>
                    :
                    <div className="table-wrapper">
                        <table>
                            <thead>
                                <tr>
                                    <th>Приход/Разход</th>
                                    <th>От</th>
                                    <th>Дата</th>
                                    <th>
                                        <span
                                            className={`quantity-filter ${materials.filter.price == 'price-desc' ? 'rotate' : ''}`}
                                            onClick={handleQuantityFilter}
                                        >
                                            На стойност
                                        <img src={tableFilterIcon} alt="Наличност" />
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {materials.data.map(material =>
                                    <Material
                                        key={material.id}
                                        material={material}
                                    />
                                )}
                            </tbody>
                        </table>
                    </div>
            }
        </div>
    )
}

export default Index